import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { timer, throwError, Observable } from 'rxjs';
import { finalize, catchError, retryWhen } from 'rxjs/operators';
import { LoaderService } from './loader.service';
import { map, mergeMap  } from 'rxjs/operators';
import { NotifierService } from '../service/notifier.service';
import { Router } from '@angular/router';

export interface RetryParams {
  maxAttempts?: number;
  scalingDuration?: number;
  shouldRetry?: ({ status: number }) => boolean;
}

const defaultParams: RetryParams = {
  maxAttempts: 3,
  scalingDuration: 1000,
  shouldRetry: ({ status }) => status >= 400
}

export const genericRetryStrategy = (params: RetryParams = {}, loaderService: LoaderService, notifierService: NotifierService) => (attempts: Observable<any>) => attempts.pipe(
  mergeMap((error, i) => {
    const { maxAttempts, scalingDuration, shouldRetry } = { ...defaultParams, ...params }
    const retryAttempt = i + 1;
    // if maximum number of retries have been met
    // or response is a status code we don't wish to retry, throw error
    if (retryAttempt > maxAttempts || !shouldRetry(error)) {

      if (retryAttempt > maxAttempts) {
        var respontxt = `Internal Server Error: status code ${error.status}`;
        notifierService.showNotification(respontxt, 'OK', 'error');
        console.log(error.message);
      }

      return throwError(error);
    }
    loaderService.pendingRequestsCount++;
    loaderService.setLoading(true);

    console.log(`Attempt ${retryAttempt}: retrying in ${retryAttempt * scalingDuration}ms`);
    // retry after 1s, 2s, etc...
    return timer(retryAttempt * scalingDuration);
  })

);
@Injectable({
  providedIn: 'root'
})
export class InterceptorService implements HttpInterceptor {

 
  private reqarray: HttpRequest<any>[] = []

  constructor(public loaderService: LoaderService, private notifierService: NotifierService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { shouldRetry } = this;
    return this.httprequestcustom(req, next, shouldRetry)
    
  }

  httprequestcustom(req: HttpRequest<any>, next: HttpHandler, shouldRetry) {
    // Skip loading indicator if the request has skipLoader header
    const skipLoader = req.headers.get('skipLoader') === 'true';
    
    if (!skipLoader) {
      this.loaderService.pendingRequestsCount++;
      this.loaderService.setLoading(true);
    }
    
    return next.handle(req).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          //var respontxt = '';
          //switch (event.status) {
          //  case 200: {
          //    respontxt = `Sign in success.`;
          //    break;
          //  }
          //  default: {
          //    respontxt = `Sign in success.`;
          //    break;
          //  }

          //}
          //if (respontxt != '') {
          //  this.notifierService.showNotification(respontxt, 'OK', 'success');
          //}
        }


        return event;
      }),
      finalize(
        () => {
          if (!skipLoader) {
            this.loaderService.finalRequestsCount++;

            if (this.loaderService.pendingRequestsCount <= this.loaderService.finalRequestsCount) {
              this.loaderService.setLoading(false);
            }
          }
        }
      ),
      catchError((err: any) => {
        var respontxt = '';

        //localStorage.clear();
        //this.router.navigate(['/']);

        switch (err.status) {
          case 400: {
            respontxt = `Bad Request: status code ${err.status}`;
            break;
          }
          case 401: {
            respontxt = `Unauthorized: status code ${err.status}`;
            break;
          }
          case 404: {
            respontxt = `Not Found: status code ${err.status}`;
            break;
          }
          case 403: {
            respontxt = `Access Denied: status code ${err.status}`;
            break;
          }
          case 500: {
            respontxt = ``;
            break;
          }
          default: {
            respontxt = `Unknown Server Error: status code ${err.status}`;
            break;
          }

        }

        //setTimeout(function () { location.reload(); }, 1);

        if (respontxt != '') {
          this.notifierService.showNotification(respontxt, 'OK', 'error');
          console.log(err.message);
        }

        return throwError(err);

      }),
      retryWhen(genericRetryStrategy({
        shouldRetry
      }, this.loaderService, this.notifierService))
    )
  }

  addpendingcall() {
    this.loaderService.pendingRequestsCount++;
  }

  private shouldRetry = (error) => error.status === 500;

}
